import Helper from './Helper';
import Accesibility from './Accessibility';

class NavDropdown {

  constructor() {
    this.header = document.querySelector('.header');

    this.dropDownTogglerClass = 'js-nav-dropdown-toggler';
    this.togglerSelector = '.menu__link--level-0';
    this.togglerArray = Array.prototype.slice.call(document.querySelectorAll(this.togglerSelector));

    this.dropdown = document.querySelector('.header__nav-dropdown');

    this.fileID = '#js-nav-file';

    this.openClass = 'open';

    this.html = document.querySelector('html');

    this.closeLink = document.querySelector('#js-close-nav-dropdown');

    this.mobileMenuOpen = false;
    this.mobileMenu = document.querySelector('.header__bottom');
    this.initDesktopDone = false;
    this.initMobileDone = false;

    if(this.header && this.closeLink){
      this.checkScreen();
      window.addEventListener('resize', () => {
        this.checkScreen();
      });
      window.addEventListener("orientationchange", () => {
        window.setTimeout(() => {
          this.checkScreen();
        }, 200);
      });
    }
  }

  checkScreen() {
    if(window.innerWidth > 991){
      if(this.initDesktopDone){
        // console.log('was already desktop');
      } else {
        this.bindEventsDesktop();
        this.initDesktopDone = true;
      }
    } else{
      if(this.initMobileDone){
        // console.log('was already mobile');
      } else {
        this.bindEventsMobile();
        this.initMobileDone = true;
      }
    }
  }

  bindEventsDesktop() {
    // console.log('desktop nav');
    //DESKTOP NAV
    this.header.style.height = this.header.clientHeight;

    this.togglerArray.forEach(toggler => {
      toggler.addEventListener('click', (e) => {
        e.preventDefault();
        this.togglerClicked(e, toggler);
      });
    });

    document.addEventListener('keyup', e => {
      if (e.keyCode == 27) {
        this.closeDropdown();
      }
    });

    this.closeLink.addEventListener('click', () => {
      this.closeDropdown();
    });
  }

  bindEventsMobile() {
    //MOBILE NAV
    // console.log('mobile nav');
    this.togglerArray.forEach(toggler => {
      toggler.addEventListener('click', (e) => {
        this.mobile_toggleSubMenu(e, toggler);
      });
    });

    document.querySelector('#js-menu-toggler').addEventListener('click', (e) => {
      e.stopPropagation();
      e.preventDefault();
      const burger = document.querySelector('#js-menu-toggler');

      if(Helper.hasClass(burger, 'animate--in')){
        Helper.removeClass(burger, 'animate--in');
        Helper.addClass(burger, 'animate--out');
        this.mobile_closeMenu();
      } else {
        Helper.addClass(burger, 'animate--in');
        Helper.removeClass(burger, 'animate--out');
        this.mobile_openMenu();
      }
      // this.mobile_toggleMenu();
    });
  }

  mobile_toggleMenu(){
    if(this.mobileMenuOpen){
      this.mobile_closeMenu();
    } else{
      this.mobile_openMenu();
    }
  }

  mobile_openMenu(){
    // console.log('open menu');
    Helper.slideOpen(this.mobileMenu, true);
    this.mobileMenuOpen = true;
  }

  mobile_closeMenu(){
    // console.log('close menu');
    Helper.slideClose(this.mobileMenu);
    this.mobileMenuOpen = false;
  }

  /**
   * Mobile Clickhandler
   * @param {*} event
   */
  mobile_toggleSubMenu(e, toggler){
    // console.log('togglesubmenu');
    if(Helper.hasClass(toggler, 'open')){
      this.mobile_closeSubmenu(toggler);
    } else{
      this.mobile_openSubmenu(toggler);
    }
  }

  mobile_openSubmenu(toggler){
    // console.log('open submenu');
    Helper.addClass(toggler, 'open');
    let submenu = toggler.nextElementSibling;
    Helper.slideOpen(submenu);
  }

  mobile_closeSubmenu(toggler){
    // console.log('close submenu');
    Helper.removeClass(toggler, 'open');
    let submenu = toggler.nextElementSibling;
    Helper.slideClose(submenu);
  }

  /**
   * ClickHandler
   * @param {*} event
   */
  togglerClicked(e, toggler){
    if(Helper.hasClass(toggler, this.dropDownTogglerClass)){
      if(Helper.hasClass(toggler, 'menu__link--active')){
        this.closeDropdown();
      } else {
        this.setMenuActiveClass(toggler);
        this.fillDropdown(toggler);
        this.openDropdown();
        document.querySelector('#js-dropdown-nav .menu__item--level-1:first-child > a').focus();
      }
    } else {
      this.closeDropdown();
    }
  }

  /**
   * fill in Dropdown Data
   * @param {domObject} clickedToggler
   */
  fillDropdown(toggler){
    const data = this.getDropdownData(toggler);
    document.querySelector('#js-dropdown-nav').innerHTML = data.nav.innerHTML;

    if(this.hasFile(toggler)){
      this.replaceNavFile(this.buildFileHtml(data.file));
    } else{
      this.replaceNavFile("");
    }

  }

  /**
   * get Data for the Dropdown Menu & File
   * @param {domObject} clickedToggler
   */
  getDropdownData(toggler){
    const data = {};
    data.file = [];
    data.nav = toggler.nextElementSibling;
    if(this.hasFile(toggler)){
      data.file['title'] = toggler.querySelector('.hidden-download-title').value;
      data.file['url'] = toggler.querySelector('.hidden-download-url').value;
      data.file['preview'] = toggler.querySelector('.hidden-download-preview').value;
    }
    return data;
  }

  /**
   * Builds HTML from file array
   * @param {array} file
   */
  buildFileHtml(file){
    let html = `
    <a id="js-nav-file" target="_blank" class="nav-file" href="${file['url']}" >
      <span class="nav-file__title">${file['title']}</span>
      <img class="nav-file__img" src="${file['preview']}" title="${file['title']}" />
    </a>`;
    return html;
  }

  /**
   * Replaces Nav-File Html in Dom
   * @param {string} html
   */
  replaceNavFile(html){
    Helper.replaceInDom(document.querySelector(this.fileID), html);
  }

  /**
   * Check if Dropdown is open by hasClass
   */
  isDropdownOpen(){
    return Helper.hasClass(this.dropdown, this.openClass);
  }

  /**
   * open Dropdown by adding Class
   */
  openDropdown(){
    if(!this.isDropdownOpen()){
      Helper.addClass(this.dropdown, this.openClass);
      Helper.addClass(this.html, 'nav-dropdown-open');
      this.setDropdownHeight();
    }
  }

  setMenuActiveClass(currentToggler){
    this.togglerArray.forEach(toggler => {
      Helper.removeClass(toggler, 'menu__link--active');
    });
    Helper.addClass(currentToggler, 'menu__link--active');
  }

  setDropdownHeight(){
    let header = this.header.clientHeight;
    let headerBottom = document.querySelector('.header__bottom').clientHeight;
    let scroll = window.scrollY;
    let height;

    if(scroll > 0){
      let headerVisible = header - scroll;
      if(headerVisible < headerBottom){
        height = headerBottom;
      } else{
        height = headerVisible;
      }
    } else{
      height = header;
    }

    this.dropdown.style.height = 'calc(100vh - ' + height + 'px)';
    this.dropdown.style.top = height;
  }

  /**
   * close Dropdown by removing Class
   */
  closeDropdown(){
    const activeLink = document.querySelector('.menu__link--active');
    Helper.removeClass(activeLink, 'menu__link--active');
    activeLink.focus();
    if(this.isDropdownOpen()){
      Helper.removeClass(this.dropdown, this.openClass);
      Helper.removeClass(this.html, 'nav-dropdown-open');
    }
  }

  hasFile(toggler){
    return (toggler.querySelector('.hidden-download-title') ? true : false);
  }

} export default NavDropdown;
